import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text-subtitle mb-0" }
const _hoisted_3 = { class: "text-paragraph mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right ms-auto text-primary fa-xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex align-items-center p-4 border rounded-4 mb-4 cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handlePatientClicked', _ctx.item)))
  }, [
    _createElementVNode("img", {
      src: _ctx.item.profile_image_formatted,
      height: "50",
      width: "50",
      class: "me-3"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.item.name), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.currentTab == "single"
            ? _ctx.item.valid_appointments_count_formatted
            : _ctx.item.latest_recurrency_frequency), 1)
    ]),
    _hoisted_4
  ]))
}